import { axiosInstance } from '@config/axios-instance-v2';
import { CreatePromoCodeDto, PromoCodeDetailDto, PromoCodeListDto } from '../libs/dto';

export const url = `/admin`;

export const promoCodeService = {
  async list(hotel_id, { page = 1, per_page = 10 }: { page: number; per_page: number }) {
    if (hotel_id) {
      const response: PromoCodeListDto = await axiosInstance.get(`${url}/hotels/${hotel_id}/promo-codes`, {
        params: {
          page,
          per_page,
        },
      });
      return response;
    }
    const response: PromoCodeListDto = await axiosInstance.get(`${url}/promo-codes`, {
      params: {
        page,
        per_page,
      },
    });
    return response;
  },
  async get(hotel_id, id: string) {
    if (hotel_id) {
      const response: PromoCodeDetailDto = await axiosInstance.get(`${url}/hotels/${hotel_id}/promo-codes/${id}`, {});
      return response;
    }
    const response: PromoCodeDetailDto = await axiosInstance.get(`${url}/promo-codes/${id}`, {});
    return response;
  },
  async create(hotel_id, data: CreatePromoCodeDto) {
    if (hotel_id) {
      const response = await axiosInstance.post(`${url}/hotels/${hotel_id}/promo-codes`, data, {});
      return response;
    }
    const response = await axiosInstance.post(`${url}/promo-codes`, data, {});
    return response;
  },
  async update(hotel_id, id: string, data: CreatePromoCodeDto) {
    if (hotel_id) {
      const response = axiosInstance.put(`${url}/hotels/${hotel_id}/promo-codes/${id}`, data, {});
      return response;
    }
    const response = axiosInstance.put(`${url}/promo-codes/${id}`, data, {});
    return response;
  },
  async delete(hotel_id: string, id: string) {
    if (hotel_id) {
      const response = await axiosInstance.delete(`${url}/hotels/${hotel_id}/promo-codes/${id}`, {});
      return response;
    }
    const response = await axiosInstance.delete(`${url}/promo-codes/${id}`, {});
    return response;
  },
};
export type PromoCodeService = typeof promoCodeService;
